import { generateName } from "@common/Common";
import { ValidationError } from "@common/types";

export class ProjectClonerViewModel
{
    opened: boolean = false;

    sourceId: number | null = null;
    cloneName: string | null = null;

    cloning: boolean = false;
    nameError: string | null = null;

    show(sourceId: number, name: string)
    {
        this.sourceId = sourceId;
        this.cloneName = generateName(name);
        this.cloning = false;

        this.clearValidationErrors();

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.sourceId = null;
        this.cloneName = null;
        this.cloning = false;

        this.clearValidationErrors();
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.cloning = false;

        for (const error of errors)
        {
            if (error.Context === "Name")
            {
                this.nameError = error.Error;
            }
            else
            {
                this.nameError = error.Error;
            }
        }
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }
}